import { createAction } from "@reduxjs/toolkit";
import { CHAT_ACTIONS } from "../../types";

export const increaseUnreadCount = createAction(
  CHAT_ACTIONS.INCREASE_UNREAD_COUNT
);
